var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Breadcrumb',_vm._l((_vm.$store.state.currentPath),function(item){return _c('BreadcrumbItem',{key:item.name,attrs:{"href":item.path}},[_vm._v(_vm._s(item.title)+"\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }